<div *ngIf="!!task" class="full-height layout-row layout-align-start-center">
  <!--Contact-->
  <div class="td small flex layout-row" *ngIf="columns.contact?.enabled">
    <span appBringozPpi class="br-body-2 text-ellipsis">{{task.contact?.name || '---'}}</span>
    <span *ngIf="task.contact?.businessName"
          appBringozPpi
          class="margin-left-5 text-ellipsis">/ {{task.contact?.businessName || '---'}}</span>
  </div>

  <!--Phone-->
  <div class="td small flex layout-row" *ngIf="columns.phone?.enabled"
       [ngbTooltip]="task.contact?.phoneNo || task.contact?.additionalPhoneNo ? tooltipTmpl : null" openDelay="300"
       triggers="hover" container="body">
    <span *ngIf="task.contact?.phoneNo"
          appBringozPpi
          class="br-body-2 text-ellipsis">{{task.contact?.phoneNo | bringozPhone}}</span>
    <span *ngIf="!task.contact?.phoneNo && task.contact?.additionalPhoneNo"
          appBringozPpi
          class="br-body-2 text-ellipsis">{{task.contact.additionalPhoneNo | bringozPhone}}
    </span>

    <ng-template #tooltipTmpl>
      <div class="layout-column">
        <span *ngIf="task.contact?.phoneNo" appBringozPpi>
          {{task.contact.phoneNo | bringozPhone}}
        </span>
        <span *ngIf="task.contact?.additionalPhoneNo"
              appBringozPpi>{{task.contact.additionalPhoneNo | bringozPhone}}
        </span>
      </div>
    </ng-template>


  </div>

  <!--Locations-->
  <div class="td large flex-40 layout-row layout-align-start-center" *ngIf="columns.location?.enabled">

    <div *ngIf="task.location?.locationType === locationTypes.DEPOT"
         [ngbTooltip]="task.location?.address | bringozAddress"
         openDelay="300"
         triggers="hover" container="body"
         class="layout-row layout-align-start-center">
      <app-task-purpose [purpose]="task.purpose" [firstLetterOnly]="true"></app-task-purpose>
      <bringoz-icon iconName="depot" class="gray-102 margin-left-5"></bringoz-icon>
      <span class="br-body-2 margin-left-5 text-ellipsis">{{task.contact.name}}</span>
    </div>

    <div *ngIf="task.location?.locationType !== 'DEPOT'"
         class="layout-row layout-align-start-center"
         [ngbTooltip]="task.location?.address | bringozAddress"
         openDelay="300"
         triggers="hover" container="body">
      <app-task-purpose *ngIf="task.location?.address"
                        [purpose]="task.purpose"
                        [firstLetterOnly]="true">
      </app-task-purpose>

      <bringoz-icon *ngIf="!task.location?.address" iconName="location-required"
                    class="margin-left-5 gray-102"></bringoz-icon>

      <span class="br-body-2 text-ellipsis margin-left-5"
            [ngClass]="{'no-address': !task.location?.address}">{{task.location?.address | bringozAddress}}
      </span>
    </div>

    <app-address-quality *ngIf="task.location?.locationType !== 'DEPOT' && !!task.location?.address?.qualityGroup"
                         [address]="task.location?.address">

    </app-address-quality>


  </div>

</div>
